import React from "react";
import PoliciesTable from "./components/PoliciesTable";

const Policies = ({ module, setPolicies, baseFields = {}, customModule = null}) => {

  return (
    <div className="__container-policies">
        <PoliciesTable setPolicies={setPolicies} module={module} baseFields={baseFields} customModule={customModule}/>
    </div>
  );
};

export default Policies;
